import { FC, useCallback } from 'react'
import { getAllOrNoneStatus } from '../../../store/helpers'
import Checkbox from '../../Checkbox'
import ExpandableComponent from '../../ExpandableComponent/ExpandableComponent'
import GroupTitle from './GroupTitle'

import styles from '../GenericDropdownMenu.module.scss'

interface GroupItemProps {
  id: string
  groupName: string
  values: readonly string[]
  selectedItems: string[]
  toggleGroup: (group: readonly string[]) => () => void
  toggleSingleOption: (colId: string) => () => void
}
const GroupItem: FC<GroupItemProps> = ({
  id,
  groupName,
  values,
  selectedItems,
  toggleGroup,
  toggleSingleOption
}) => {
  const isItemSelected = (item: string) => selectedItems.includes(item)
  const allSelectedStatus = getAllOrNoneStatus(values, (column) =>
    isItemSelected(column)
  )

  const renderTitle = useCallback(
    (isExpanded: boolean, setExpanded: (expanded: boolean) => void) => (
      <GroupTitle
        status={allSelectedStatus}
        groupName={groupName}
        isExpanded={isExpanded}
        values={values}
        setExpanded={setExpanded}
        toggleGroup={toggleGroup}
      />
    ),
    [allSelectedStatus, groupName, values, toggleGroup]
  )

  return (
    <ExpandableComponent title={renderTitle} isInitiallyExpanded={false}>
      {values.map((value) => (
        <div key={value} className={styles.singleOption}>
          <Checkbox
            locator={`column-${id}-${value}`}
            checked={isItemSelected(value)}
            onChange={toggleSingleOption(value)}
          >
            {value}
          </Checkbox>
        </div>
      ))}
    </ExpandableComponent>
  )
}

export default GroupItem
